import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

type Props = {
  open: boolean;
  handleOpen: () => void;
  handleConfirm: () => void;
  description?: string;
  fieldLabel?: string;
  value?: string | number;
};

export default function ConfirmAdditionalItemChangeModal({
  open,
  handleOpen,
  handleConfirm,
  description,
  fieldLabel,
  value,
}: Props) {
  return (
    <Dialog open={open} onClose={handleOpen} maxWidth="sm" fullWidth>
      <DialogTitle>Confirmar modificación</DialogTitle>

      <DialogContent>
        <Typography>
          ¿Estás seguro que deseas modificar el{" "}
          <strong>{description || "item adicional"}</strong> con un{" "}
          <strong>{fieldLabel || "valor"}</strong> de <strong>{value ?? "-"}</strong>?
        </Typography>

        <Typography mt={2}>
          Esto afectará el subtotal de adicionales y el total de la liquidación.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={handleOpen}>Cancelar</Button>
        <Button variant="contained" onClick={handleConfirm}>
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}